<div class="content-pane">
  <h2>Add {{ model?.resource_type || 'New' | titlecase }} Resource</h2>

  <mat-horizontal-stepper linear>
    <mat-step [stepControl]="typeForm">
      <form [formGroup]="typeForm">
        <ng-template matStepLabel>Choose Resource Type</ng-template>

        <mat-radio-group formControlName="type" class="flex flex-col gap-3" (change)="onTypeChange($event.value)">
          <mat-radio-button value="Generic">Generic</mat-radio-button>
          <mat-radio-button value="Event">Event</mat-radio-button>
        </mat-radio-group>

        <div class="form-actions mt-4">
          <button type="button" matButton="filled" color="primary" matStepperNext [disabled]="!typeForm.valid">
            <mat-icon class="material-symbols-outlined">arrow_forward</mat-icon>
            Next
          </button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="form">
      <ng-template matStepLabel>Enter Details</ng-template>

      <form [formGroup]="form" (ngSubmit)="submit($event)">
        <formly-form
          [model]="model"
          [fields]="formFields"
          [options]="options"
          [form]="form"
          class="standard"
        ></formly-form>

        <div class="form-actions mt-4">
          <button matButton="filled" color="primary" type="submit" [disabled]="submitting || form.pending">
            <mat-icon class="material-symbols-outlined">check</mat-icon>
            Save
          </button>

          <button type="button" matButton="filled" matStepperPrevious>
            <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
            Back
          </button>

          <a matButton="filled" class="cancelbtn" [routerLink]="['/resource-explorer']">
            <mat-icon class="material-symbols-outlined">remove_circle</mat-icon>
            Cancel
          </a>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>
</div>
